<template>
    <div class="ion-page">
        <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
            </ion-buttons>
            <ion-buttons slot="start">
                <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
            </ion-buttons>
            <ion-title>Branches List</ion-title>

            <ion-buttons slot="end">
            <ion-button @click="addCorporateDetails" v-if="rightToAdd" class="hdrBtn">
                <ion-icon slot="start" :icon="add"></ion-icon>Add New Branch Details
                <!-- <ion-icon slot="icon-only" name="add"></ion-icon>  class="btn-add" -->
            </ion-button>
            </ion-buttons>
        </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
        <BranchCPO />
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
// @ is an alias to /src

import BranchCPO from "@/components/corporate/branchCPO.vue";

import { AppUtils } from "@/util/app-utils"
import { IonButtons, IonContent, IonHeader, IonIcon, IonMenuButton, IonTitle, IonToolbar } from "@ionic/vue";
import { add } from 'ionicons/icons';
export default defineComponent ({
    name: 'branchCPO',
    components: {
        BranchCPO, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonIcon, IonContent
    },
    data() {
        return {
            add,
            rightToAdd: false
        }
    },
    mounted() {
        this.rightToAdd = new AppUtils().getUserAccess("100|U");
    },
    methods: {
        addCorporateDetails() {
        localStorage.removeItem("branchInfo")
        this.$router.push("/corporate/branchDetails");
        },
        navigatePreviousPage() {
            this.$router.go(-1)
        }
    }
})
</script>